// extracted by mini-css-extract-plugin
export default {"cls1":"LanguageSwitcherModal-cls1__d89d3f6204f702cbb3cc","cls2":"LanguageSwitcherModal-cls2__e6f417ccfc5c1b3b100e LanguageSwitcherModal-cls1__d89d3f6204f702cbb3cc"};